import { useState } from "react";
import useScrollEffect from "./useScrollEffect";

const useCarouselPerfilLuis = (arrayLenght: number) => {
  const [imagePos, setImagePos] = useState<number>(0);
  const { imageListRef } = useScrollEffect(imagePos);

  function nextImg() {
    setImagePos(prev => {
      if (prev + 1 >= arrayLenght) return 0;
      return prev + 1;
    });
  }

  function prevImg() {
    setImagePos(prev => {
      if (prev - 1 < 0) return 5;
      return prev - 1;
    });
  }

  return { nextImg, prevImg, imageListRef };
};

export default useCarouselPerfilLuis;
